<template>
  <div class="w-100">
    <proa-card v-if="bill" class="h-100 d-flex flex-column" no-padding>
      <template v-slot:header>
        <div class="d-flex justify-content-between align-items-center">
          <proa-back-button
            @onClick="onClickBackButton"
          />
          <proa-heading detail>{{ bill.billingAt | moment('YYYY/MM/DD') }}</proa-heading>
          <div></div>
        </div>
      </template>
      <div class="bill-content">
        <div class="table-outer-wrapper">
          <div class="table-inner-scroll-wrapper">
            <table class="table-attributes">
              <tbody>
                <tr>
                  <th>{{ $t('pages.showManagementBillingHistories.billingAmountForCurrentMonth') }}</th>
                  <td>{{ bill.billingAmount | currencyJPY }}</td>
                </tr>
                <tr>
                  <th>{{ $t('pages.showManagementBillingHistories.billingAt') }}</th>
                  <td>{{ bill.billingAt | moment('MM/DD') }}</td>
                </tr>
              </tbody>
            </table>
            <div class="separater">{{ $t('pages.showManagementBillingHistories.separaterCurrentMonth') }}</div>
            <table class="table-attributes">
              <tbody>
                <tr v-if="basePlanInvoice">
                  <th>{{ $t('pages.showManagementBillingHistories.basicPlan') }}</th>
                  <td class="fixed">{{ basePlanInvoice.itemName }}</td>
                  <td class="fixed">{{ basePlanInvoice.chargeAmount | currencyJPY }}</td>
                  <td>（{{ basePlanInvoice.chargeAt | moment('M月') }}{{ $t('pages.showManagementBillingHistories.usage') }}）</td>
                </tr>
                <tr
                  v-for="(baseOptionInvoice, index) of baseOptionInvoices"
                  :key="baseOptionInvoice.id"
                  :class="baseOptionInvoices.length === 1 ? '' : index === 0 ? 'first-cell' : index === baseOptionInvoices.length - 1 ? 'last-cell' : 'intermediate-cell'"
                >
                  <th>{{ index === 0 ? $t('pages.showManagementBillingHistories.options') : '' }}</th>
                  <td>{{ baseOptionInvoice.itemName }}</td>
                  <td>{{ baseOptionInvoice.chargeAmount | currencyJPY }}</td>
                  <td>（{{ baseOptionInvoice.chargeAt | moment('M月') }}{{ $t('pages.showManagementBillingHistories.usage') }}）</td>
                </tr>
                <tr class="first-cell enable-bottom-padding">
                  <th>{{ $t('pages.showManagementBillingHistories.paymentDetail') }}</th>
                  <td>{{ $t('pages.showManagementBillingHistories.creditCardPayment') }}</td>
                </tr>
                <template v-if="basePayment">
                  <tr class="intermediate-cell">
                    <th></th>
                    <td class="text-secondary">{{ $t('pages.showManagementBillingHistories.paymentNumber') }}</td>
                    <td>{{ basePayment.paymentNumber }}</td>
                  </tr>
                  <tr class="intermediate-cell">
                    <th></th>
                    <td class="text-secondary">{{ $t('pages.showManagementBillingHistories.paymentResult') }}</td>
                    <td>
                      <span v-if="basePayment.paymentResult == 1">{{ $t('common.ok') }}</span>
                      <span v-else-if="basePayment.paymentResult == 2 || basePayment.paymentResult == 3" class="text-error">{{ $t('common.error') }}</span>
                    </td>
                  </tr>
                  <tr class="intermediate-cell">
                    <th></th>
                    <td class="text-secondary">{{ $t('pages.showManagementBillingHistories.paymentCardApprovalNumber') }}</td>
                    <td>{{ basePayment.cardApprovalNumber }}</td>
                  </tr>
                  <tr v-if="basePayment.errorCode" class="intermediate-cell">
                    <th></th>
                    <td class="text-secondary">{{ $t('pages.showManagementBillingHistories.paymentErrorCode') }}</td>
                    <td>{{ basePayment.errorCode }}</td>
                  </tr>
                  <tr class="intermediate-cell">
                    <th></th>
                    <td class="text-secondary">{{ $t('pages.showManagementBillingHistories.paymentAmount') }}</td>
                    <td>{{ basePayment.paymentAmount | currencyJPY }}</td>
                  </tr>
                  <tr class="intermediate-cell">
                    <th></th>
                    <td class="text-secondary">{{ $t('pages.showManagementBillingHistories.paymentKickbackAt') }}</td>
                    <td>{{ basePayment.kickbackAt | moment('YYYY/MM/DD') }}</td>
                  </tr>
                  <tr class="intermediate-cell">
                    <th></th>
                    <td class="text-secondary">{{ $t('pages.showManagementBillingHistories.paymentAutoBillingNumber') }}</td>
                    <td>{{ basePayment.autoBillingNumber }}</td>
                  </tr>
                  <tr class="last-cell">
                    <th></th>
                    <td class="text-secondary">{{ $t('pages.showManagementBillingHistories.paymentStatus') }}</td>
                    <td>{{ basePayment.status }}</td>
                  </tr>
                </template>
              </tbody>
            </table>
            <template v-if="onetimePlanInvoices.length || onetimeOptionInvoices.length">
              <div class="separater">{{ $t('pages.showManagementBillingHistories.separaterLastMonthDiff') }}</div>
              <table class="table-attributes">
                <tbody>
                  <tr
                    v-for="(onetimePlanInvoice, index) of onetimePlanInvoices"
                    :key="onetimePlanInvoice.id"
                    :class="onetimePlanInvoices.length === 1 ? '' : index === 0 ? 'first-cell' : index === onetimePlanInvoices.length - 1 ? 'last-cell' : 'intermediate-cell'"
                  >
                    <th>{{ index === 0 ? $t('pages.showManagementBillingHistories.basicPlan') : '' }}</th>
                    <td class="fixed">{{ onetimePlanInvoice.itemName }}{{ $t('pages.showManagementBillingHistories.changeTo') }}</td>
                    <td class="fixed">{{ onetimePlanInvoice.chargeAmount | currencyJPY }}</td>
                    <td>
                      <span>（{{ onetimePlanInvoice.chargeAt | moment('M月') }}{{ $t('pages.showManagementBillingHistories.usage') }} {{ $t('pages.showManagementBillingHistories.planDifference') }}</span>
                      <span>：{{ $t('pages.showManagementBillingHistories.changeDate') }} {{ onetimePlanInvoice.chargeAt | moment('MM/DD') }}）</span>
                    </td>
                  </tr>
                  <tr
                    v-for="(onetimeOptionInvoice, index) of onetimeOptionInvoices"
                    :key="onetimeOptionInvoice.id"
                    :class="onetimeOptionInvoices.length === 1 ? '' : index === 0 ? 'first-cell' : index === onetimeOptionInvoices.length - 1 ? 'last-cell' : 'intermediate-cell'"
                  >
                    <th>{{ index === 0 ? $t('pages.showManagementBillingHistories.additionalOptions') : '' }}</th>
                    <td>{{ onetimeOptionInvoice.itemName }}</td>
                    <td>{{ onetimeOptionInvoice.chargeAmount | currencyJPY }}</td>
                    <td>
                      <span v-if="onetimeOptionInvoice.itemType.includes('Discount')">
                        （{{ lastMonth(onetimeOptionInvoice.chargeAt) | moment('M月') }}{{ $t('pages.showManagementBillingHistories.usage') }}
                      </span>
                      <span v-else>（{{ onetimeOptionInvoice.chargeAt | moment('M月') }}{{ $t('pages.showManagementBillingHistories.usage') }}</span>
                      <span>：{{ $t('pages.showManagementBillingHistories.changeDate') }} {{ onetimeOptionInvoice.chargeAt | moment('MM/DD') }}）</span>
                    </td>
                  </tr>
                  <template v-if="onetimePayment">
                    <tr class="first-cell enable-bottom-padding">
                      <th>{{ $t('pages.showManagementBillingHistories.paymentDetail') }}</th>
                      <td>{{ $t('pages.showManagementBillingHistories.creditCardPayment') }}</td>
                    </tr>
                    <tr class="intermediate-cell">
                      <th></th>
                      <td class="text-secondary">{{ $t('pages.showManagementBillingHistories.paymentNumber') }}</td>
                      <td>{{ onetimePayment.paymentNumber }}</td>
                    </tr>
                    <tr class="intermediate-cell">
                      <th></th>
                      <td class="text-secondary">{{ $t('pages.showManagementBillingHistories.paymentResult') }}</td>
                      <td>
                        <span v-if="onetimePayment.paymentResult == 1">{{ $t('common.ok') }}</span>
                        <span v-else-if="onetimePayment.paymentResult == 2 || onetimePayment.paymentResult == 3" class="text-error">{{ $t('common.error') }}</span>
                      </td>
                    </tr>
                    <tr class="intermediate-cell">
                      <th></th>
                      <td class="text-secondary">{{ $t('pages.showManagementBillingHistories.paymentCardApprovalNumber') }}</td>
                      <td>{{ onetimePayment.cardApprovalNumber }}</td>
                    </tr>
                    <tr v-if="onetimePayment.errorCode" class="intermediate-cell">
                      <th></th>
                      <td class="text-secondary">{{ $t('pages.showManagementBillingHistories.paymentErrorCode') }}</td>
                      <td>{{ onetimePayment.errorCode }}</td>
                    </tr>
                    <tr class="intermediate-cell">
                      <th></th>
                      <td class="text-secondary">{{ $t('pages.showManagementBillingHistories.paymentAmount') }}</td>
                      <td>{{ onetimePayment.paymentAmount | currencyJPY }}</td>
                    </tr>
                    <tr class="intermediate-cell">
                      <th></th>
                      <td class="text-secondary">{{ $t('pages.showManagementBillingHistories.paymentKickbackAt') }}</td>
                      <td>{{ onetimePayment.kickbackAt | moment('YYYY/MM/DD') }}</td>
                    </tr>
                    <tr class="last-cell">
                      <th></th>
                      <td class="text-secondary">{{ $t('pages.showManagementBillingHistories.paymentStatus') }}</td>
                      <td>{{ onetimePayment.status }}</td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </template>
          </div>
        </div>
      </div>
      <div v-if="showDownloadPDF" class="bill-card-footer">
        <div v-if="disabledDownloadPDF" class="disabled-download-pdf-message">{{ $t('pages.showManagementBillingHistories.disabledDownloadPDFMessage') }}</div>
        <proa-button
          class="default-button-width"
          :disabled="disabledDownloadPDF"
          @click.native="onClickDownloadPDF"
        >
          {{ $t('pages.showManagementBillingHistories.downloadDetailedPDF') }}
        </proa-button>
      </div>
    </proa-card>
    <pdf-modal
      :modalWithObject="pdfModalWithObject"
      @close="pdfModalWithObject = null"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import Bill from '@/store/models/admin/Bill'
import PdfModal from '@/components/molecules/management/billingHistories/PDFModal'

export default {
  name: 'ShowManagementBillingHistories',
  components: {
    PdfModal
  },
  computed: {
    billId: function() { return this.$route.params.id },
    bill: function() { return Bill.find(this.billId) },
    basePayment: function() {
      // NOTE: required
      return this.bill.payments.filter((payment) => payment.paymentType === 'auto')[0]
    },
    basePlanInvoice: function() {
      // NOTE: required
      return this.bill.invoices.filter((invoice) => invoice.itemType === 'planBase')[0]
    },
    baseOptionInvoices: function() {
      return this.bill.invoices.filter((invoice) => {
        return invoice.itemType === 'optionRoomBase' ||
               invoice.itemType === 'optionSeatBase' ||
               invoice.itemType === 'trialDiscountBase' ||
               invoice.itemType === 'couponDiscountBase'
      })
    },
    disabledDownloadPDF: function() {
      return (this.basePayment && this.basePayment.paymentResult != 1) ||
             (this.onetimePayment && this.onetimePayment.paymentResult != 1)
    },
    lastMonth: function() {
      return (chargeAt) => {
        return moment(chargeAt).add(-1, 'months')
      }
    },
    onetimePayment: function() {
      // NOTE: optional
      return this.bill.payments.filter((payment) => payment.paymentType === 'onetime')[0]
    },
    onetimePlanInvoices: function() {
      return this.bill.invoices.filter((invoice) => invoice.itemType === 'plan')
    },
    onetimeOptionInvoices: function() {
      return this.bill.invoices.filter((invoice) => {
        return invoice.itemType === 'optionRoom' ||
               invoice.itemType === 'optionSeat' ||
               invoice.itemType === 'trialDiscount' ||
               invoice.itemType === 'couponDiscount'
      })
    },
    showDownloadPDF: function() {
      return this.bill.billingAmount >= 1
    },
    ...mapGetters({
      currentOrganization: 'auth/currentOrganization',
      getDownloadPDFURL: 'entities/bills/getDownloadPDFURL'
    })
  },
  data() {
    return {
      pdfModalWithObject: null
    }
  },
  methods: {
    onClickBackButton: function() {
      this.$router.push({ name: 'indexManagementBillingHistories' })
    },
    onClickDownloadPDF: function() {
      this.pdfModalWithObject = {
        url: this.getDownloadPDFURL(this.billId),
        fileName: `Sharewind請求明細-${this.currentOrganization.name}-${moment(this.bill.billingAt).format('YYYY-MM-DD')}.pdf`
      }
    },
    ...mapActions({
      apiGetBill: 'entities/bills/show',
      getDownloadBillPDFURL: 'entities/bills/getDownloadPDFURL'
    })
  },
  created() {
    this.apiGetBill(this.billId)
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

.bill-content {
  flex-grow: 1;
  height: 100%;
  display: flex;
  flex-direction: column;

  .table-outer-wrapper {
    position: relative;
    height: 100%;
  }

  .table-inner-scroll-wrapper {
    position: absolute;
    max-height: 100%;
    width: 100%;
    overflow-y: auto;
  }

  .table-attributes {
    width: 100%;

    tr {
      display: block;
      border-bottom: 1px solid $light-border-color;
      padding: 15px 20px;

      @include mq(md) {
        display: table-row;
        border-bottom: 1px solid $dark-border-color;
        padding: 0;
      }

      &.first-cell {
        border-bottom: none;

        &:not(.enable-bottom-padding) {
          th, td {
            padding-bottom: 2px;
          }
        }
      }

      &.intermediate-cell {
        border-bottom: none;

        th, td {
          padding-top: 0;
          padding-bottom: 2px;
        }
      }

      &.last-cell {
        th, td {
          padding-top: 0;
        }
      }
    }

    th {
      display: block;
      width: 140px;
      padding: 0;
      font-weight: 600;

      @include mq(md) {
        display: table-cell;
        white-space: nowrap;
        padding: 20px 0 20px 20px;
      }
    }

    td {
      display: block;
      width: 100%;
      padding: 0;
      word-break: break-all;
      margin: 10px 0;

      @include mq(md) {
        display: table-cell;
        width: auto;
        white-space: nowrap;
        padding: 20px 20px 20px 0;
      }

      &.fixed {
        width: 100px !important;
      }
    }
  }

  .separater {
    height: 26px;
    padding-left: 20px;
    font-size: 13px;
    background-color: $light-gray-color;
    color: $secondary-color;
    display: flex;
    align-items: center;
  }
}

.bill-card-footer {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 20px;
  border-top: 1px solid $dark-border-color;

  @include mq(md) {
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
  }

  .disabled-download-pdf-message {
    font-size: 13px;
    font-weight: 600;
    margin-right: 10px;
    color: $secondary-color;
  }
}
</style>
